import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as Icons from "lucide-react";
import { getUserFromToken } from "../../../Utils/TokenVerify";
import ApiService from "../../../Services/user/service";
import Swal from "sweetalert2";

const Deposit = () => {
  const navigate = useNavigate();
  const TokenData = getUserFromToken();
  const user_id = TokenData?.user_id;
  const currency = localStorage.getItem("currentCurrency") ?? "1"; // 1 is INR, 0 is USD

  const [userdetails, setUserdetails] = useState({});
  const [adminBankDetails, setAdminBankDetails] = useState(null);

  const [amount, setAmount] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [receiptBase64, setReceiptBase64] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    fetchuserdetails();
  }, []);

  useEffect(() => {
    // Attempt to get parent_id from localStorage or fallback to userdetails
    let parent_id = localStorage.getItem("parent_id");
    if (!parent_id && userdetails?.parent_id) {
       parent_id = userdetails.parent_id;
    }
    if (parent_id) {
       fetchAdminBankDetails(parent_id);
    }
  }, [userdetails]);

  const fetchuserdetails = async () => {
    try {
      const res = await ApiService.getUserDetail(user_id);
      setUserdetails(res?.data?.data[0] || {});
    } catch (err) {
      console.log(err);
    }
  };

  const fetchAdminBankDetails = async (parent_id) => {
    try {
      if (parent_id) {
        const res = await ApiService.adminGetUpi(parent_id);
        console.log("adminGetUpi response:", res);
        if (res.status) {
          setAdminBankDetails(res.data?.data || res.data);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  let availableBalance = 0;
  if (userdetails && Object.keys(userdetails).length > 0) {
    if (currency === "1") {
      availableBalance = userdetails.Inr_Balance || 0;
    } else {
      availableBalance = userdetails.Balance || 0;
    }
  }

  const handleAmountClick = (val) => {
    setAmount(Number(amount || 0) + val);
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    Swal.fire({
      icon: "success",
      title: "Copied!",
      text: "Copied to clipboard.",
      timer: 1000,
      showConfirmButton: false,
    });
  };

  const handleReceiptUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      setReceiptBase64(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = async () => {
    if (!amount || Number(amount) <= 0) {
      Swal.fire({ icon: "error", title: "Invalid", text: "Enter valid deposit amount" });
      return;
    }
    if (!transactionId) {
      Swal.fire({ icon: "error", title: "Invalid", text: "Enter transaction ID" });
      return;
    }
    if (!receiptBase64) {
      Swal.fire({ icon: "error", title: "Invalid", text: "Upload payment receipt" });
      return;
    }

    setIsSubmitting(true);
    const payload = {
      userid: user_id,
      Balance: Number(amount),
      type: 1, // 1 = deposit
      transactionId: transactionId,
      ScreenShot: receiptBase64,
    };

    try {
      if (currency === "1") {
        await ApiService.withdrawalDepositInr(payload);
      } else {
        await ApiService.withdrawalDeposit(payload);
      }
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Deposit request submitted",
        timer: 1500,
        showConfirmButton: false,
      });
      navigate(-1);
    } catch (err) {
      console.error(err);
      Swal.fire({ icon: "error", title: "Failed", text: "Deposit failed" });
    } finally {
      setIsSubmitting(false);
    }
  };

  const isINR = currency === "1";
  const symbol = isINR ? "₹" : "$";
  const upiId = isINR ? adminBankDetails?.walleturl : adminBankDetails?.walleturl1;
  const qrCode = isINR ? adminBankDetails?.qrCodeBase64 : adminBankDetails?.qrCodeBase641;
  const bankName = isINR ? adminBankDetails?.bankname : adminBankDetails?.bankname1;
  const accHolderName = isINR ? adminBankDetails?.accountholdername : adminBankDetails?.accountholdername1;
  const accNumber = isINR ? adminBankDetails?.accountnumber : adminBankDetails?.accountnumber1;
  const branch = isINR ? adminBankDetails?.branchname : adminBankDetails?.branchname1;
  const ifscCode = isINR ? adminBankDetails?.ifsc : adminBankDetails?.ifsc1;

  return (
    <div className="mobile-deposit-container">
      <style>
        {`
          .mobile-deposit-container {
            background-color: #ffffff;
            color: #000000;
            font-family: 'Inter', sans-serif;
            
            margin-top: 47px
            border-radius: 8px;
            box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
           
          }

          .deposit-header {
            display: flex;
            align-items: center;
            padding: 20px 15px;
            background-color: #0b4a3b;
            color: white;
            font-size: 1.25rem;
            font-weight: 600;
            margin-top: 27px;
          }
          .deposit-content {
            padding: 15px;
          }
          .balance-card {
            background-color: #f8f9fa;
            border: 1px solid #eee;
            border-radius: 12px;
            padding: 15px 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 25px;
          }
          .balance-card span {
            font-size: 1rem;
            color: #666;
          }
          .balance-card h4 {
            margin: 0;
            font-size: 1.2rem;
            color: #000;
          }
          .input-group-custom {
            position: relative;
            margin-bottom: 15px;
          }
          .input-group-custom span {
            position: absolute;
            left: 15px;
            top: 50%;
            transform: translateY(-50%);
            color: #888;
            font-size: 1.2rem;
          }
          .input-group-custom input {
            width: 100%;
            background-color: #f8f9fa;
            border: 1px solid #ddd;
            border-radius: 10px;
            padding: 15px 15px 15px 40px;
            color: #000;
            font-size: 1.1rem;
            outline: none;
          }
          .amount-chips {
            display: flex;
            gap: 10px;
            margin-bottom: 25px;
          }
          .amount-chip {
            flex: 1;
            background-color: #4a6ee0;
            color: white;
            border: none;
            border-radius: 8px;
            padding: 10px;
            font-size: 0.9rem;
            font-weight: 600;
          }
          .upi-card {
            border: 1px solid #20c997;
            border-radius: 12px;
            padding: 15px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
            background-color: #ffffff;
          }
          .upi-left {
            display: flex;
            align-items: center;
            gap: 15px;
          }
          .upi-icon {
            color: #20c997;
          }
          .upi-details p {
            margin: 0;
            font-size: 0.8rem;
            color: #333;
          }
          .upi-details h6 {
            margin: 0;
            font-size: 1rem;
            color: #000;
          }
          .copy-icon {
            color: #333;
            cursor: pointer;
          }
          .bank-qr-wrapper {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 20px;
            margin-bottom: 20px;
          }
          @media (max-width: 768px) {
            .bank-qr-wrapper {
              flex-direction: column;
              align-items: flex-start;
            }
          }
          .bank-details-card {
            background-color: #ffffff;
            border-radius: 12px;
            padding: 20px;
            margin-bottom: 0;
            flex: 1;
            color: #000;
          }
          .bank-row {
            display: flex;
            margin-bottom: 12px;
            font-size: 0.9rem;
          }
          .bank-row:last-child {
            margin-bottom: 0;
          }
          .bank-label {
            color: #333;
            width: 150px;
          }
          .bank-value {
            color: #000;
            font-weight: 600;
          }
          .qr-container {
            display: flex;
            justify-content: center;
            margin: 0;
          }
          .qr-image {
            width: 200px;
            height: 200px;
            background-color: white;
            padding: 10px;
            border-radius: 10px;
          }
          .form-label {
            color: #333;
            font-size: 0.9rem;
            margin-bottom: 8px;
            display: block;
          }
          .file-input {
            width: 100%;
            background-color: #f8f9fa;
            border: 1px solid #ddd;
            border-radius: 10px;
            padding: 12px;
            color: #000;
            margin-bottom: 15px;
          }
          .text-input {
            width: 100%;
            background-color: #f8f9fa;
            border: 1px solid #ddd;
            border-radius: 10px;
            padding: 15px;
            color: #000;
            margin-bottom: 25px;
            outline: none;
          }
          .submit-btn {
            width: 100%;
            background-color: #0b4a3b;
            color: white;
            border: none;
            border-radius: 10px;
            padding: 15px;
            font-size: 1.1rem;
            font-weight: 600;
          }
        `}
      </style>

      {/* HEADER */}
      <div className="deposit-header">
        <Icons.ArrowLeft size={24} onClick={() => navigate(-1)} style={{ cursor: "pointer", marginRight: "15px" }} />
        <span>Add Funds</span>
      </div>

      <div className="deposit-content">
        <div className="balance-card">
          <span>Trading Balance</span>
          <h4>{symbol} {availableBalance.toFixed(2)}</h4>
        </div>

        <label className="form-label">Enter {isINR ? "INR" : "USD"}</label>
        <div className="input-group-custom">
          <span>{symbol}</span>
          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="0"
          />
        </div>

        <div className="amount-chips">
          {isINR ? (
            <>
              <button className="amount-chip" onClick={() => handleAmountClick(10000)}>+ {symbol}10,000</button>
              <button className="amount-chip" onClick={() => handleAmountClick(25000)}>+ {symbol}25,000</button>
              <button className="amount-chip" onClick={() => handleAmountClick(50000)}>+ {symbol}50,000</button>
            </>
          ) : (
            <>
              <button className="amount-chip" onClick={() => handleAmountClick(100)}>+ {symbol}100</button>
              <button className="amount-chip" onClick={() => handleAmountClick(500)}>+ {symbol}500</button>
              <button className="amount-chip" onClick={() => handleAmountClick(1000)}>+ {symbol}1000</button>
            </>
          )}
        </div>

        {upiId && (
          <div className="upi-card">
            <div className="upi-left">
              <Icons.QrCode className="upi-icon" size={28} />
              <div className="upi-details">
                <p>{isINR ? "UPI ID" : "Wallet Address"}</p>
                <h6>{upiId}</h6>
              </div>
            </div>
            <Icons.Copy className="copy-icon" size={20} onClick={() => handleCopy(upiId)} />
          </div>
        )}

        <div className="bank-qr-wrapper">
          <div className="bank-details-card">
            {bankName && (
              <div className="bank-row">
                <div className="bank-label">Bank Name :</div>
                <div className="bank-value">{bankName}</div>
              </div>
            )}
            {accHolderName && (
              <div className="bank-row">
                <div className="bank-label">Account Holder Name :</div>
                <div className="bank-value">{accHolderName}</div>
              </div>
            )}
            {accNumber && (
              <div className="bank-row">
                <div className="bank-label">Account Number :</div>
                <div className="bank-value">{accNumber}</div>
              </div>
            )}
            {branch && (
              <div className="bank-row">
                <div className="bank-label">Branch :</div>
                <div className="bank-value">{branch}</div>
              </div>
            )}
            {ifscCode && (
              <div className="bank-row">
                <div className="bank-label">IFSC :</div>
                <div className="bank-value">{ifscCode}</div>
              </div>
            )}
          </div>

          {qrCode && (
            <div className="qr-container">
              <img src={qrCode} alt="QR Code" className="qr-image" />
            </div>
          )}
        </div>

        <label className="form-label">Payment Receipt</label>
        <input type="file" accept="image/*" className="file-input" onChange={handleReceiptUpload} />

        <label className="form-label">Transaction ID / UTR</label>
        <input
          type="text"
          className="text-input"
          placeholder="Enter 12-digit UTR or Txn ID"
          value={transactionId}
          onChange={(e) => setTransactionId(e.target.value)}
        />

        <button className="submit-btn" onClick={handleSubmit} disabled={isSubmitting}>
          {isSubmitting ? "Submitting..." : "Submit Deposit"}
        </button>
      </div>
    </div>
  );
};

export default Deposit;
